import UpcomingEvents from "./UpcomingEvents";

export default UpcomingEvents;
